import type { Directive } from 'vue';

function update(el: HTMLElement, binding) {

    const url = binding.value;
    el.style.backgroundImage = url !== null ? 'url(' + url + ')' : null;
}

export const backgroundImageDirective: Directive = {

    mounted: update,
    updated: update
}